module.exports = __webpack_public_path__ + "img/yapikredi_logo.1c21c384.svg";